import React from 'react';
import { DialogContent } from '@biome-design-system/ui/DialogContent';
import { Button } from '@biome-design-system/ui/Button';
import { Dialog } from '@biome-design-system/ui/Dialog';

export const PatientSearchRefiner = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={true}
      data-testid="patient-search-refiner-dialog"
    >
      <DialogContent>
        {/* TODO patient search refiner component goes here, might need to style/tweak the paper component in styles.jsx */}
        <Button
          color="primary"
          data-testid="biome-button"
          onClick={onClose}
          style={{
            marginBottom: '.5rem',
            marginRight: '.5rem'
          }}
          variant="outlined"
        >
          Skip to results/Back
        </Button>
        <Button
          color="neutral"
          data-testid="biome-button"
          onClick={onClose}
          style={{
            marginBottom: '.5rem',
            marginRight: '.5rem'
          }}
          variant="outlined"
        >
          Placeholder question button
        </Button>
      </DialogContent>
    </Dialog>
  );
};
